import { ContentStateInterface, SiteRecommendedUseTypes, SiteRecommendedUseTypesProps } from '../../@types/types'
import { ChipGroupFeature } from '../../components/common/inputs/chipsGroup/ChipsGroup'
import { siteRecommendedUseTypesLanguages } from './siteRecommendedUseTypes'

export const getSiteRecommendedUseTypes = (
  realEstateSiteRecommendedTypes: SiteRecommendedUseTypesProps[],
  insertionData: ContentStateInterface
): ChipGroupFeature[] => {
  return realEstateSiteRecommendedTypes.map((useType: SiteRecommendedUseTypesProps) => ({
    property: `siteRecommendedUseTypes.${useType.property}`,
    translationKey: useType.translationKey,
    value: insertionData.siteRecommendedUseTypes?.[useType.property as keyof SiteRecommendedUseTypes] ?? false,
    defaultTranslationText: siteRecommendedUseTypesLanguages[useType.property],
  }))
}
